/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_RefusedInputs */

const en_vendor_return_status_refused = /** @type {(inputs: Vendor_Return_Status_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused by the supplier`)
};

/**
* | output |
* | --- |
* | "Refused by the supplier" |
*
* @param {Vendor_Return_Status_RefusedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_refused = /** @type {((inputs?: Vendor_Return_Status_RefusedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_RefusedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_refused(inputs)
});